import { Navigate } from '@sorare/routing';

import { FOOTBALL_PLAY_RIVALS_ARENA } from '@sorare/core/src/constants/__generated__/routes';

import { useFootballEventOnce } from '@sorare/gameplay/src/lib/events';

import { FavoriteClubSelection } from 'components/rivals/Onboarding/FavoriteClubSelection';
import { useRivalsOnboarding } from 'components/rivals/Onboarding/useRivalsOnboarding';

const OnboardingClubSelectionPage = () => {
  const { onboardingEnabled } = useRivalsOnboarding();
  const trackOnce = useFootballEventOnce();

  if (!onboardingEnabled) {
    return <Navigate to={FOOTBALL_PLAY_RIVALS_ARENA} replace />;
  }

  trackOnce('Viewed PickFavoriteTeamScreen');

  return <FavoriteClubSelection />;
};
export default OnboardingClubSelectionPage;
